import React from 'react';
import ReactDOM from 'react-dom';
import "./index.css";
import Game from './components/Game';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Game />
  </React.StrictMode>
);


